export const getGditProduct = state => state.editProduct
